import { SelectOptionType } from '@octano/global-ui';

export enum StudentWarningsGroupType {
  Academic = 'academic',
  Health = 'health',
  Behavior = 'behavior',
}

export enum StudentWarningsRiskLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export type StudentWarningsSummaryFormData = {
  schools: SelectOptionType[];
  years: SelectOptionType[];
  periods: SelectOptionType[];
  studyPlans: SelectOptionType[];
  campuses: SelectOptionType[];
  warningGroups: SelectOptionType[];
};

export type StudentWarningsSummaryRow = {
  studyPlanEnrollmentId: number;
  name: string;
  identification: string;
  studyPlan: string;
  campus: string;
  promo: string;
  course: string;
  warnings: Record<string, number>;
  riskLevel: StudentWarningsRiskLevel;
};

export type StudentWarningsSummaryDataParams = {
  warningGroupType: string;
  schoolId?: string;
  periodId?: string;
  year?: number;
  riskLevel?: string;
  studyPlanId?: string;
  campusId?: string;
  name?: string;
};

export type StudentWarningsSummaryDetailsParams = {
  warningGroupType: StudentWarningsGroupType;
  studyPlanEnrollmentId: string;
  periodId: string;
  year: string;
};

export type StudentWarningsSummaryDetailsWarning = {
  type: string;
  name: string;
  warnings: number;
  riskLevel: StudentWarningsRiskLevel;
};

export type StudentWarningsSummaryFormDetailsResponse = {
  warningGroups: SelectOptionType[];
  years: SelectOptionType[];
  periods: SelectOptionType[];
  behaviorRecordSeverities: SelectOptionType[];
  behaviorRecordTypes: SelectOptionType[];
  healthRecordStates: SelectOptionType[];
  healthRecordTypes: SelectOptionType[];
  healthRecordSubTypes: SelectOptionType[];
};

export type StudentWarningsSummaryDetailsResponse = {
  student: {
    name: string;
    identification: {
      type: string;
      value: string;
    };
  };
  studyPlan: string;
  promo: string;
  course: string;
  warnings: StudentWarningsSummaryDetailsWarning[];
  groupData?: any;
};
